import styled from "styled-components"
import { maxWidth, minWidth } from "utils"
import CategoryIcon from "icons/categories"
import eq from "utils/eq"

export const Wrapper = styled.div`
  width: calc(100% - 3.8rem);
  margin: 0 1.9rem 2rem;

  ${minWidth.tablet`
    max-width: 58rem;
    flex-direction: column;
    width: 100%;
    margin: 0 auto 2rem;
  `}

  ${minWidth.desktop`
    max-width: 72.5rem;
  `}

  ${eq("isFeatured", false)`
    ${minWidth.rightRail`
      max-width: unset;
      width: unset;
      margin-left: calc((100% - 72.5rem) / 2);
      margin-right: 0.8rem;
      margin-top: unset;
      margin-bottom: 3rem;
    `}
  `}
`

export const SubcategoryContainer = styled.div`
  margin-bottom: 2.5rem;
  display: flex;
  flex-direction: column;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.17;
  text-transform: uppercase;
  letter-spacing: 0.2rem;

  ${minWidth.tablet`
    flex-direction: row;
  `}
`

export const Left = styled.a`
  margin-right: 1rem;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.article.color};
`

export const Right = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: center;
  color: #767676;

  ${minWidth.tablet`
    margin-top: 0;
  `}
`

export const VerticalPipe = styled.span`
  margin-right: 1rem;
  display: none;

  ${minWidth.tablet`
    display: block;
  `}
`

export const Title = styled.h1`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.8rem;
  font-weight: 400;
  line-height: 1.27;

  ${minWidth.tablet`
    font-size: 3.5rem;
    line-height: 1.23;
  `}

  ${minWidth.hamburgerLarge`
    font-size: 4rem;
    line-height: 1.2;
  `}
`

export const TooltipBody = styled.div`
  width: 34.6rem;
  position: absolute;
  z-index: 1;
  top: 50px;
  left: 50px;

  ${maxWidth.mobile`
    width: 32rem;
    left: -7.2rem;
  `}

  color: ${(props) => props.theme.colors.text.primary};
  background: #fff;
  box-shadow: 0 1px 25px 0 rgba(145, 145, 145, 0.35);
  border-radius: 0.6rem;
  padding: 2rem 3rem;

  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.33;
  text-align: left;
`
